import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import { Link, useParams } from "react-router-dom";
import "./common.css";
import API_URL from "../common/Apiurl";
import SuccessMessage from '../common/Message';

function Payoutview() {
  const apiUrl = API_URL;
  const [items, setItems] = useState();
  const viewId = useParams();
  const payoutid = viewId.payoutid;
  const [successMessages, setSuccessMessages] = useState([]);
  const getComments = async () => {
    try {
      const postData = {
        id: payoutid,
      };
      const res = await fetch(`${apiUrl}/admin/payout_details`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(postData),
      });
      const data = await res.json();
      if (data.status !== 200) {
        throw new Error("Data not found");
      }
      console.log(data);
      // debugger
      setItems(data.data[0]);
    } catch (error) {
      console.error("Error ", error);
    }
  };
  useEffect(() => {
    getComments();
  }, []);
  const handleChange = async (e) => {
    // setText(e.target.value);
    const postData = {
        wallet_transaction_id: payoutid,
        wallet_transaction_status: e.target.value
    }
    const result = await fetch(`${apiUrl}/admin/transaction_done`,{
        method: "POST",
        headers:{
            "Content-Type":"application/json",
            "Accept":"application/json"
        },
        body:JSON.stringify(postData) 
    });
    const data = await result.json();
    if((data.status === 200)){
        const newSuccessMessage = data.message;
        setSuccessMessages([...successMessages, newSuccessMessage]);
    }else if((data.status === 400)){
        const newSuccessMessage = data.message;
        setSuccessMessages([...successMessages, newSuccessMessage]);
    }
  }
  const handleSuccessMessageFadeOut = () =>{
    setSuccessMessages((prevMessages) => prevMessages.slice(1));
    getComments();
}
  return (
    <div className="width90">
      <h2 className="pageTitle">View Payout</h2>
      <div className="commonCntr">
        <div className="form-horizontal" action="">
          <div className="form-group">
            <label className="control-label col-sm-2 label">User Name:</label>
            {/* <div className="col-sm-10 mt-1"> */}
            <span>
              {items ? items.user.name + " " + items.user.lastname : ""}
            </span>
            {/* </div> */}
          </div>
          <div className="form-group">
            <label className="control-label col-sm-2 label">User Email:</label>
            {/* <div className="col-sm-10 mt-1"> */}
            <span>{items ? items.user.email : ""}</span>
            {/* </div> */}
          </div>
          <div className="form-group">
            <label className="control-label col-sm-2 label">
              User Mobile Number:
            </label>
            {/* <div className="col-sm-10 mt-1"> */}
            <span>{items ? items.user.mobile_number : ""}</span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Coins Requested:
            </label>
            {/* <div className="col-sm-10 mt-1"> */}
            <span>{items ? items.coin : ""}</span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Coins Left:</label>
            {/* <div className="col-sm-10 mt-1"> */}
            <span>{items ? items.wallet_coin : ""}</span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Amount left:</label>
            {/* <div className="col-sm-10 mt-1"> */}
            <span>{items ? items.wallet_amount : ""}</span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Account Number:
            </label>
            {/* <div className="col-sm-10 mt-1"> */}
            <span>{items ? items.bank_details.account_number : ""}</span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">MCC:</label>
            {/* <div className="col-sm-10 mt-1"> */}
            <span>{items ? items.bank_details.mcc : ""}</span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Mode:</label>
            {/* <div className="col-sm-10 mt-1"> */}
            <span>{items ? items.bank_details.mode : ""}</span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Sort Code:</label>
            {/* <div className="col-sm-10 mt-1"> */}
            <span>{items ? items.bank_details.sort_code : ""}</span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Business Name:
            </label>
            {/* <div className="col-sm-10 mt-1"> */}
            <span>{items ? items.bank_details.business_name : ""}</span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">DOB:</label>
            {/* <div className="col-sm-10 mt-1"> */}
            <span>
              {items
                ? items.bank_details.birth_day +
                  "/" +
                  items.bank_details.birth_month +
                  "/" +
                  items.bank_details.birth_year
                : ""}
            </span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Address:</label>
            {/* <div className="col-sm-10 mt-1"> */}
            <span>
              {items
                ? items.bank_details.line1 +
                  "," +
                  items.bank_details.state +
                  " " +
                  items.bank_details.postal_code
                : ""}
            </span>
            {/* </div> */}
          </div>
          {items ? (
            items.transaction_status === "pending" ? (
              <div className="form-group mt-4">
                <select value={items.transaction_status} onChange={handleChange}>
                    <option value="pending">Pending</option>
                    <option value="success">Success</option>
                    <option value="processing">Processing</option>
              </select>
              </div>
            ) : (
                <div className="form-group mt-4">
                    <label className="control-label col-sm-2 label">Sort Code:</label>
                    {/* <div className="col-sm-10 mt-1"> */}
                    <span>{items ? items.transaction_status : ""}</span>
                    {/* </div> */}
                </div>
            )
          ) : (
            ""
          )}
        </div>
      </div>
    {
        successMessages.map((message, index) => (
            <SuccessMessage
                key={index} 
                message = {message} 
                onFadeOut={handleSuccessMessageFadeOut}
            />
        )
    )}
    </div>
  );
}

export default Payoutview;
